import Api from '@/services/api.js';

export default {
  addRcti(rcti) {
    return Api.post('rctis/add', rcti);
  },
  addRctis(rctis) {
    return Api.post('rctis/addMultiple', rctis);
  },
  getAllRctis() {
    return Api.get('rctis');
  },
  getRctis(payload) {
    return Api.post('rctis/getBy', payload);
  },
  getRctisByBillingPeriod(billingPeriod) {
    return Api.get(`rctis/byBillingPeriod/${billingPeriod}`);
  },
  getConfirmedRctis() {
    return Api.get('rctis/confirmed');
  },

  getUnConfirmedRctis() {
    return Api.get('rctis/unconfirmed');
  },

  getFinalisedRctis() {
    return Api.get('rctis/finalised');
  },
  updateRcti(rcti) {
    return Api.put(`rctis/${rcti.id}`, rcti);
  },
  updateRctis(ids) {
    return Api.patch(`rctis/rctis`, ids);
  },
  deleteRcti(id) {
    return Api.delete(`rctis/${id}`);
  },
  deleteRctis(obj) {
    return Api.post(`rctis/deleteMultiple`, obj);
  }

}